import { SoapUtils } from "../../../utils/SoapUtils";
import { Employments, Folder, Industries, toEmploymentsXml, toFolderXml, toIndustriesXml } from "./Folder";

export interface Person {
    id?:                   string;
    treeHandle?:           string;
    aclh?:                 string;
    account?:              string;
    accresponsiblePerson?: string;
    accresponsibleUserId?: string;
    bankCode?:             string;
    bankName?:             string;
    category?:             string;
    sysUser?:              string;
    sysUserName?:          string;
    description?:          string;
    keyId?:                string;
    adsAllowed?:           string;
    validFrom?:            string;
    validTo?:              string;
    modified?:             string;
    oldId?:                string;
    position?:             string;
    positionInfo?:         string;
    reference?:            string;
    swiftCode?:            string;
    sourceDb?:             string;
    trackingCode?:         string;
    name1?:                string;
    name2?:                string;
    name3?:                string;
    city?:                 string;
    country?:              string;
    fax?:                  string;
    icq?:                  string;
    mobile?:               string;
    phone?:                string;
    email?:                string;
    other?:                string;
    twitter?:              string;
    facebook?:             string;
    pager?:                string;
    region?:               string;
    street?:               string;
    zip?:                  string;
    dueDays?:              string;
    bankIBAN?:             string;
    bankNoteForeign?:      string;
    consentStatus?:        string;
    consentNote?:          string;
    anonymized?:           string;
    employer?:             string;
    massmailEnabledFrom?:  string;
    massmailEnabledTo?:    string;
    massmailEnabled?:      string;
    ADDRESSES?:            Addresses;
    CONTACTS?:             Contacts;
    BANKS?:                Banks;
    DGROUPS?:              Dgroups;
    EXTERNAL_IDS?:         string;
    PERSONINFO?:           Personinfo;
    EMPLOYMENTS?:          Employments;
    RELATIONS?:            Relations;
    FOLDERS?:              Folders;
    COMPANYINFO?:          Companyinfo;
    INDUSTRIES?:           Industries;
    DOCUMENT?:             Document[];
}

export function toPersonXml(p:Person, root:string = 'PERSON'):string{
    var result = '';
    result += SoapUtils.makeNode(p.id, 'id');
    result += SoapUtils.makeNode(p.treeHandle, 'treeHandle');
    result += SoapUtils.makeNode(p.aclh, 'aclh');
    result += SoapUtils.makeNode(p.account, 'account');
    result += SoapUtils.makeNode(p.accresponsiblePerson, 'accresponsiblePerson');
    result += SoapUtils.makeNode(p.accresponsibleUserId, 'accresponsibleUserId');
    result += SoapUtils.makeNode(p.bankCode, 'bankCode');
    result += SoapUtils.makeNode(p.bankName, 'bankName');
    result += SoapUtils.makeNode(p.category, 'category');
    result += SoapUtils.makeNode(p.sysUser, 'sysUser');
    result += SoapUtils.makeNode(p.sysUserName, 'sysUserName');
    result += SoapUtils.makeNode(p.description, 'description');
    result += SoapUtils.makeNode(p.keyId, 'keyId');
    result += SoapUtils.makeNode(p.adsAllowed, 'adsAllowed');
    result += SoapUtils.makeNode(p.validFrom, 'validFrom');
    result += SoapUtils.makeNode(p.validTo, 'validTo');
    result += SoapUtils.makeNode(p.modified, 'modified');
    result += SoapUtils.makeNode(p.oldId, 'oldId');
    result += SoapUtils.makeNode(p.position, 'position');
    result += SoapUtils.makeNode(p.positionInfo, 'positionInfo');
    result += SoapUtils.makeNode(p.reference, 'reference');
    result += SoapUtils.makeNode(p.swiftCode, 'swiftCode');
    result += SoapUtils.makeNode(p.sourceDb, 'sourceDb');
    result += SoapUtils.makeNode(p.trackingCode, 'trackingCode');
    result += SoapUtils.makeNode(p.name1, 'name1');
    result += SoapUtils.makeNode(p.name2, 'name2');
    result += SoapUtils.makeNode(p.name3, 'name3');
    result += SoapUtils.makeNode(p.city, 'city');
    result += SoapUtils.makeNode(p.country, 'country');
    result += SoapUtils.makeNode(p.fax, 'fax');
    result += SoapUtils.makeNode(p.icq, 'icq');
    result += SoapUtils.makeNode(p.mobile, 'mobile');
    result += SoapUtils.makeNode(p.other, 'other');
    result += SoapUtils.makeNode(p.twitter, 'twitter');
    result += SoapUtils.makeNode(p.facebook, 'facebook');
    result += SoapUtils.makeNode(p.pager, 'pager');
    result += SoapUtils.makeNode(p.region, 'region');
    result += SoapUtils.makeNode(p.street, 'street');
    result += SoapUtils.makeNode(p.zip, 'zip');
    result += SoapUtils.makeNode(p.dueDays, 'dueDays');
    result += SoapUtils.makeNode(p.bankIBAN, 'bankIBAN');
    result += SoapUtils.makeNode(p.bankNoteForeign, 'bankNoteForeign');
    result += SoapUtils.makeNode(p.consentStatus, 'consentStatus');
    result += SoapUtils.makeNode(p.consentNote, 'consentNote');
    result += SoapUtils.makeNode(p.anonymized, 'anonymized');
    result += SoapUtils.makeNode(p.employer, 'employer');
    result += SoapUtils.makeNode(p.massmailEnabledFrom, 'massmailEnabledFrom');
    result += SoapUtils.makeNode(p.massmailEnabledTo, 'massmailEnabledTo');
    result += SoapUtils.makeNode(p.massmailEnabled, 'massmailEnabled');
    if(p.ADDRESSES) result += toAddressesXml(p.ADDRESSES);
    if(p.CONTACTS) result += toContactsXml(p.CONTACTS);
    if(p.BANKS) result += toBanksXml(p.BANKS);
    if(p.DGROUPS) result += toDgroupsXml(p.DGROUPS);
    if(p.EXTERNAL_IDS) result += `<EXTERNAL_IDS>${p.EXTERNAL_IDS}</EXTERNAL_IDS>`;
    if(p.PERSONINFO) result += toPersoninfoXML(p.PERSONINFO);
    if(p.EMPLOYMENTS) result += toEmploymentsXml(p.EMPLOYMENTS);
    if(p.RELATIONS) result += toRelationsXml(p.RELATIONS);
    if(p.FOLDERS) result += toFoldersXml(p.FOLDERS);
    if(p.COMPANYINFO) result += toCompanyinfoXml(p.COMPANYINFO);
    if(p.INDUSTRIES) result += toIndustriesXml(p.INDUSTRIES);
    if(p.DOCUMENT) result += p.DOCUMENT.map(d => toDocumentXml(d)).join('');

    return `<${root}>${result}</${root}>`;
}

export interface Addresses {
    ADDRESS?: Address[];
}

function toAddressesXml(a:Addresses):string{
    var result = '<ADDRESSES>';
    if(a.ADDRESS){
        a.ADDRESS.forEach(address => {
            result += toAddressXml(address);
        });
    }
    result += '</ADDRESSES>';
    return result;
}

export interface Address {
    city?:       string;
    cityName?:   string;
    country?:    string;
    isPrimary?:  string;
    region?:     string;
    regionName?: string;
    street?:     string;
    type?:       string;
    zip?:        string;
    zipName?:    string;
}

function toAddressXml(a:Address):string {
    var result = '';
    result += SoapUtils.makeNode(a.city, 'city');
    result += SoapUtils.makeNode(a.cityName, 'cityName');
    result += SoapUtils.makeNode(a.country, 'country');
    result += SoapUtils.makeNode(a.isPrimary, 'isPrimary');
    result += SoapUtils.makeNode(a.region, 'region');
    result += SoapUtils.makeNode(a.regionName, 'regionName');
    result += SoapUtils.makeNode(a.street, 'street');
    result += SoapUtils.makeNode(a.type, 'type');
    result += SoapUtils.makeNode(a.zip, 'zip');
    result += SoapUtils.makeNode(a.zipName, 'zipName');

    return `<ADDRESS>${result}</ADDRESS>`;
}

export interface Companyinfo {
    regNumber?:number;
    VATNumber?:number
    legalForm?:     string;
    legalFormName?: string;
}

function toCompanyinfoXml(ci:Companyinfo):string{
    var result = '';
    result += SoapUtils.makeNode(ci.regNumber, 'regNumber');
    result += SoapUtils.makeNode(ci.VATNumber, 'VATNumber');
    result += SoapUtils.makeNode(ci.legalForm, 'legalForm');
    result += SoapUtils.makeNode(ci.legalFormName, 'legalFormName');

    return `<COMPANYINFO>${result}</COMPANYINFO>`;
}

export interface Contacts {
    CONTACT?: Contact[];
}

function toContactsXml(c:Contacts):string{
    var result = '<CONTACTS>';
    if(c.CONTACT){
        c.CONTACT.forEach(contact => {
            result += toContactXml(contact);
        });
    }
    result += '</CONTACTS>';
    return result;
}

export interface Contact {
    content?:     string;
    description?: string;
    isMain?:      string;
    isPrimary?:   string;
    type?:        string;
    typeName?:    string;
    typeType?:    string;
    category?:    string;
}

function toContactXml(c:Contact):string{
    var result = '';
    result += SoapUtils.makeNode(c.content, 'content');
    result += SoapUtils.makeNode(c.description, 'description');
    result += SoapUtils.makeNode(c.isMain, 'isMain');
    result += SoapUtils.makeNode(c.isPrimary, 'isPrimary');
    result += SoapUtils.makeNode(c.type, 'type');
    result += SoapUtils.makeNode(c.typeName, 'typeName');
    result += SoapUtils.makeNode(c.typeType, 'typeType');
    result += SoapUtils.makeNode(c.category, 'category');

    return `<CONTACT>${result}</CONTACT>`;
}

export interface Banks {
    BANK: Bank[];
}

function toBanksXml(b:Banks):string{
    var result = '<BANKS>';
    if(b.BANK) {
        b.BANK.forEach(bank => {
            result += toBankXml(bank);
        });
    }
    result += '</BANKS>';
    return result;
}

export interface Bank {
    name?:            string;
    bankName?:        string;
    account?:         string;
    bankCode?:        string;
    swiftCode?:       string;
    variableSymbol?:  string;
    constantSymbol?:  string;
    specificSymbol?:  string;
    comment?:         string;
    isPrimary?:       string;
    bankIBAN?:        string;
    bankNoteForeign?: string;
}

function toBankXml(b:Bank):string{
    var result = '';
    result += SoapUtils.makeNode(b.name, 'name');
    result += SoapUtils.makeNode(b.bankName, 'bankName');
    result += SoapUtils.makeNode(b.account, 'account');
    result += SoapUtils.makeNode(b.bankCode, 'bankCode');
    result += SoapUtils.makeNode(b.swiftCode, 'swiftCode');
    result += SoapUtils.makeNode(b.variableSymbol, 'variableSymbol');
    result += SoapUtils.makeNode(b.constantSymbol, 'constantSymbol');
    result += SoapUtils.makeNode(b.specificSymbol, 'specificSymbol');
    result += SoapUtils.makeNode(b.comment, 'comment');
    result += SoapUtils.makeNode(b.isPrimary, 'isPrimary');
    result += SoapUtils.makeNode(b.bankIBAN, 'bankIBAN');
    result += SoapUtils.makeNode(b.bankNoteForeign, 'bankNoteForeign');

    return `<BANK>${result}</BANK>`;
}

export interface Dgroups {
    DGROUP?: Dgroup[];
}

function toDgroupsXml(d:Dgroups):string{
    var result = '<DGROUPS>';
    if(d.DGROUP){
        d.DGROUP.forEach(dgroup => {
            result += toDgroupXml(dgroup);
        });
    }
    result += '</DGROUPS>';
    return result;
}

export interface Dgroup {
    id?:      string;
    name?:   string;
    comment?: string;
}

function toDgroupXml(d:Dgroup):string{
    var result = '';
    result += SoapUtils.makeNode(d.id, 'id');
    result += SoapUtils.makeNode(d.name, 'name');
    result += SoapUtils.makeNode(d.comment, 'comment');
    return `<DGROUP>${result}</DGROUP>`;
}

export interface Personinfo {
    prefixTitle?:   string;
    postfixTitle?:  string;
    sex?:           string;
    maritalStatus?: string;
    born?:          string;
    salutation?:    string;
    preferedLang?:  string;
}

function toPersoninfoXML(pi: Personinfo):string{
    var result = '';

    result += SoapUtils.makeNode(pi.prefixTitle, 'prefixTitle');
    result += SoapUtils.makeNode(pi.postfixTitle, 'postfixTitle');
    result += SoapUtils.makeNode(pi.sex, 'sex');
    result += SoapUtils.makeNode(pi.maritalStatus, 'maritalStatus');
    result += SoapUtils.makeNode(pi.born, 'born');
    result += SoapUtils.makeNode(pi.salutation, 'salutation');
    result += SoapUtils.makeNode(pi.preferedLang, 'preferedLang');

    return `<PERSONINFO>${result}</PERSONINFO>`;
}

export interface Relations {
    RELATION?: Relation[];
}

function toRelationsXml(r:Relations):string{
    var result = '<RELATIONS>';
    if(r.RELATION){
        r.RELATION.forEach(relation => {
            result += toRelationXml(relation);
        });
    }
    result += '</RELATIONS>';
    return result;
}

export interface Relation {
    contact?:       string;
    rSwap?:         string;
    contact1Id?:    string;
    contact2Id?:    string;
    contact1Name1?: string;
    contact1Name2?: string;
    contact1Name3?: string;
    contact2Name1?: string;
    contact2Name2?: string;
    contact2Name3?: string;
    contact1Phone?: string;
    contact2Phone?: string;
    contact1Email?: string;
    contact2Email?: string;
    description?:   string;
    relation?:      string;
    typeName1?:     string;
    typeName2?:     string;
}

function toRelationXml(r:Relation):string{
    var result = '';
    result += SoapUtils.makeNode(r.contact, 'contact');
    result += SoapUtils.makeNode(r.rSwap, 'rSwap');
    result += SoapUtils.makeNode(r.contact1Id, 'contact1Id');
    result += SoapUtils.makeNode(r.contact2Id, 'contact2Id');
    result += SoapUtils.makeNode(r.contact1Name1, 'contact1Name1');
    result += SoapUtils.makeNode(r.contact1Name2, 'contact1Name2');
    result += SoapUtils.makeNode(r.contact1Name3, 'contact1Name3');  
    result += SoapUtils.makeNode(r.contact2Name1, 'contact2Name1');
    result += SoapUtils.makeNode(r.contact2Name2, 'contact2Name2');
    result += SoapUtils.makeNode(r.contact2Name3, 'contact2Name3');
    result += SoapUtils.makeNode(r.contact1Phone, 'contact1Phone');
    result += SoapUtils.makeNode(r.contact2Phone, 'contact2Phone');
    result += SoapUtils.makeNode(r.contact1Email, 'contact1Email');
    result += SoapUtils.makeNode(r.contact2Email, 'contact2Email');  
    result += SoapUtils.makeNode(r.description, 'description');
    result += SoapUtils.makeNode(r.relation, 'relation');
    result += SoapUtils.makeNode(r.typeName1, 'typeName1');
    result += SoapUtils.makeNode(r.typeName2, 'typeName2');

    return `<RELATION>${result}</RELATION>`;
}

export interface Folders {
    FOLDER?: Folder[];
}

function toFoldersXml(f:Folders):string{
    var result = '<FOLDERS>';
    if(f.FOLDER){
        f.FOLDER.forEach(folder => {
            result += toFolderXml(folder);
        });
    }
    result += '</FOLDERS>';
    return result;
}

export interface Document {
    documentId?: number;
    name?: string;
    description?: string;
    isPrimaryPicture?: boolean;
}

function toDocumentXml(d:Document):string{
    var result = '';
    result += SoapUtils.makeNode(d.documentId, 'documentId');
    result += SoapUtils.makeNode(d.name, 'name');
    result += SoapUtils.makeNode(d.description, 'description');
    if(d.isPrimaryPicture!=undefined) result += `<isPrimaryPicture>${d.isPrimaryPicture ? 1 : false}</isPrimaryPicture>`;
    return `<DOCUMENT>${result}</DOCUMENT>`;
}